import React from 'react';

type ThumbnailImageProps = {
	src?: string;
	alt?: string;
	placeholderImage: string;
	style?: React.CSSProperties;
};

const ThumbnailImage: React.FC<ThumbnailImageProps> = ({
	src,
	alt = 'thumbnail',
	placeholderImage,
	style,
}) => {
	const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
		e.currentTarget.onerror = null; // Prevent infinite loop
		e.currentTarget.src = placeholderImage;
	};

	return (
		<img
			src={src || placeholderImage}
			alt={alt}
			style={{
				maxWidth: '120px',
				maxHeight: '100px',
				objectFit: 'cover',
				backgroundColor: '#eee',
				...style,
			}}
			width={'auto'}
			height={100}
			onError={handleError}
		/>
	);
};

export default ThumbnailImage;
